import React from "react";

import { Users } from "react-feather";
import { RouteInfoType } from "../../types/types";
import AuthLayout from "../../layouts/Auth"

import SignIn from "./pages/signIn"
import SignUp from "./pages/signUp"
import SignUpAfterSignIn from "./pages/signUpAfterSignIn"


const authRoutes = {
    id: "auth",
    path: "/auth",
    name: "auth",
    icon: <Users/>,
    hide: true,
    component: AuthLayout,
    routes: [
        {
            path: "/auth/sign-in",
            name: "signIn",
            component: SignIn
        },
        {
            path: "/auth/sign-up",
            name: "signUp",
            component: SignUp
        },
        {
            path: "/auth/:phone/create-account",
            name: "signUp",
            component: SignUpAfterSignIn,
        }
    ]
} as RouteInfoType;


export default authRoutes;
